export const API_PATHS = {
  COMMUNICATION_PREFERENCES: "/v1/communication-preferences",
};

export const QUERY_KEYS = {
  COMMUNICATION_PREFERENCES: "communication-preferences",
};

export const MUTATION_KEYS = {
  COMMUNICATION_PREFERENCES: {
    PATCH: "PATCH-COMMUNICATION-PREFERENCES",
  },
};

export const PREFERENCE_ID_MAP = {
  email: "email-notification",
  text: "text-notification",
  paperReport: "paper-reports",
};
